import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import FlowExplorer from '@/components/feature/FlowExplorer';
import { serviceFlow, serviceTypes } from '@/mocks/jiuchou-business';

export default function ServiceBusiness() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="服务业务"
            title="从卖商品，到卖服务"
            subtitle="九畴云铺不是只有「卖商品」。从服务者创建服务，到用户购买、预约、履约、评价与结算，形成完整的服务经济闭环。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12">
            <FlowExplorer steps={serviceFlow} direction="horizontal" accent="accent" dark />
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div className="mt-10">
            <div className="text-center text-sm font-medium text-foreground-300 mb-5">
              服务类型
            </div>
            <div className="flex flex-wrap justify-center gap-2">
              {serviceTypes.map((t) => (
                <span
                  key={t}
                  className="px-4 py-2 rounded-full bg-background-50/10 border border-background-50/15 text-background-100 text-sm whitespace-nowrap"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-10 text-center">
            <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-primary-500/15 border border-primary-500/30 text-primary-300 text-sm font-medium">
              <i className="ri-stack-line"></i>
              最终形成：商品经济 + 服务经济
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}